// (function () {
//   if (!window.PVSTORIES || !PVSTORIES.ajaxUrl) {
//     console.warn("[views-stories] Нет PVSTORIES или ajaxUrl");
//     return;
//   }

//   function getSlides() {
//     return Array.from(document.querySelectorAll(".stories__item[data-index]"));
//   }

//   function updateViews() {
//     var slides = getSlides();
//     if (!slides.length) return;

//     var storiesPostId = slides[0].getAttribute("data-stories-post-id");
//     if (!storiesPostId) {
//       console.warn("[views-stories] Нет data-stories-post-id на слайдах");
//       return;
//     }

//     var indexes = [];
//     var map = {};

//     slides.forEach(function (slide) {
//       var idx = slide.getAttribute("data-index");
//       if (idx === null || idx === "") return;

//       if (!map[idx]) {
//         map[idx] = [];
//         indexes.push(idx);
//       }
//       map[idx].push(slide);
//     });

//     if (!indexes.length) return;

//     var fd = new FormData();
//     fd.append("action", "pv_story_get_views");
//     fd.append("stories_post_id", String(storiesPostId));
//     indexes.forEach(function (i) {
//       fd.append("indexes[]", i);
//     });

//     fetch(PVSTORIES.ajaxUrl, {
//       method: "POST",
//       body: fd,
//       credentials: "same-origin",
//     })
//       .then((r) => r.json())
//       .then((d) => {
//         if (!d || !d.success || !d.data || !d.data.items) return;

//         var items = d.data.items;
//         Object.keys(items).forEach(function (idx) {
//           var val = String(items[idx]);
//           (map[idx] || []).forEach(function (slide) {
//             var el = slide.querySelector(".stories__views-count");
//             if (el) el.textContent = val;
//           });
//         });
//       })
//       .catch((e) => console.error("[views-stories] fetch error", e));
//   }

//   if (document.readyState === "loading")
//     document.addEventListener("DOMContentLoaded", updateViews);
//   else updateViews();

//   window.addEventListener("pageshow", function (e) {
//     if (e.persisted) updateViews();
//   });

//   window.PVSTORIES_updateViews = updateViews;
// })();
(function () {
  if (!window.PVSTORIES || !PVSTORIES.ajaxUrl) {
    console.warn("[views-stories] Нет PVSTORIES или ajaxUrl");
    return;
  }

  function getSlides() {
    return Array.from(document.querySelectorAll(".stories__item[data-story-id]"));
  }

  function updateViews() {
    var slides = getSlides();
    if (!slides.length) return;

    var storiesPostId = slides[0].getAttribute("data-stories-post-id");
    if (!storiesPostId) {
      console.warn("[views-stories] Нет data-stories-post-id на слайдах");
      return;
    }

    var storyIds = [];
    var map = {};

    slides.forEach(function (slide) {
      var storyId = slide.getAttribute("data-story-id");
      if (!storyId) return;

      if (!map[storyId]) {
        map[storyId] = [];
        storyIds.push(storyId);
      }

      map[storyId].push(slide);
    });

    if (!storyIds.length) return;

    var fd = new FormData();
    fd.append("action", "pv_story_get_views");
    fd.append("stories_post_id", String(storiesPostId));

    storyIds.forEach(function (id) {
      fd.append("story_ids[]", id);
    });

    fetch(PVSTORIES.ajaxUrl, {
      method: "POST",
      body: fd,
      credentials: "same-origin",
    })
      .then((r) => r.json())
      .then((d) => {
        if (!d || !d.success || !d.data || !d.data.items) return;

        var items = d.data.items;

        Object.keys(items).forEach(function (storyId) {
          var val = String(items[storyId]);
          (map[storyId] || []).forEach(function (slide) {
            var el = slide.querySelector(".stories__views-count");
            if (el) el.textContent = val;
          });
        });
      })
      .catch((e) => console.error("[views-stories] fetch error", e));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateViews);
  } else {
    updateViews();
  }

  window.addEventListener("pageshow", function (e) {
    if (e.persisted) updateViews();
  });

  window.PVSTORIES_updateViews = updateViews;
})();